import React from "react";
import { Twitter, Facebook, Instagram, Youtube, Linkedin } from "lucide-react";
import { SiX, SiLinkedin } from "react-icons/si"; // X (new Twitter) & LinkedIn
import './Footer.css';
import { useNavigate } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Left Section */}
        <div className="footer-left">
          <div
            className="footer-logo-wrapper"
            onClick={() => navigate("/")}
            style={{ cursor: "pointer" }}
          >
            <img
              src="/Images/AATTUM-Logo.png"
              alt="AATTUM Logo"
              className="footer-logo-img"
            />
            <h2 className="footer-logo-text11">
              <span className="highlight11">AATTUM</span> TPL
            </h2>
          </div>


          <p className="footer-text">
            Empowering talent through sports excellence connecting athletes,
            coaches, and clubs for a brighter sporting future.
          </p>

         <div className="social-icons">
  <a href="https://x.com/Aattumtpl" target="_blank" rel="noopener noreferrer">
    <SiX />
  </a>
  <a href="https://www.facebook.com/profile.php?id=61583551081281" target="_blank" rel="noopener noreferrer">
    <Facebook />
  </a>
  <a href="https://www.instagram.com/aattumtpl/" target="_blank" rel="noopener noreferrer">
    <Instagram />
  </a>
  <a href="https://www.youtube.com/@aattumtpl" target="_blank" rel="noopener noreferrer">
    <Youtube />
  </a>
  <a href="https://www.linkedin.com/in/aattum-tpl-92981a390/" target="_blank" rel="noopener noreferrer">
    <SiLinkedin />
  </a>
</div>

        </div>

        {/* Right Section */}
        <div className="footer-right">
          <div className="footer-column">
            <h4>COMPANY</h4>
            <ul>
              <li><a href="/about-tpl">About</a></li>
                <li><a href="/sponsor">Sponsors</a></li>
              <li><a href="/AtplGallery">Gallery</a></li>
             
              <li><a href="/blogs">Blogs</a></li>
            </ul>
          </div>

          <div className="footer-column">
            <h4>HELP</h4>
            <ul>
              <li><a href="/contact-us">Customer Support</a></li>
              <li><a href="/privacy-policy">Privacy Policy</a></li>
              {/* <li><a href="/tplchildrenpolicies">Children Policy</a></li>
              <li><a href="/tplpolicies">Registration Policy</a></li> */}
              <li><a href="/sports-documents">Required Documents</a></li>
            </ul>
          </div>

          <div className="footer-column">
            <h4>CONTACT</h4>
            <ul>
              <li><a href="mailto:info@tplsports.com">admin@aattumtpl.com </a></li>
              <li><a href="#">+91 93848 20659</a></li>
              <li><a href="#">Chennai, India</a></li>
            </ul>
          </div>
        </div>
      </div>

      <hr className="footer-divider" />

      <div className="footer-bottom">
        <p>© 2026 Aattum TPL. All Rights Reserved</p>
      </div>
    </footer>
  );
};

export default Footer;
